import axios from 'axios';

/**
 * Live job-preset counts and revenue totals, shared by the sidebar submenu
 * (App.vue) and the on-page preset bar (Jobs.vue) so both read one cached copy.
 * Both are decorative — failures leave the previous values in place and never
 * block the list. The preset filter payloads come from the caller (the admin
 * job-preset registry), keeping this module free of any preset definitions.
 */
export const moduleName = 'jobPresets';

// Skip refetching if the last fetch is younger than this (both surfaces trigger
// a fetch; this stops app-startup + navigation from hammering the endpoint).
const STALE_MS = 60 * 1000;

export default {
  namespaced: true,
  state: {
    counts: {},
    // Summed job revenue per preset id, same keys as `counts`.
    revenues: {},
    fetchedAt: 0,
    loading: false,
  },
  mutations: {
    setTotals(state, { counts, revenues }) {
      state.counts = { ...state.counts, ...counts };
      state.revenues = { ...state.revenues, ...revenues };
      state.fetchedAt = Date.now();
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
  actions: {
    async fetchCounts({ state, commit }, { requests, force = false } = {}) {
      if (!requests || !requests.length) return;
      if (
        !force &&
        state.fetchedAt &&
        Date.now() - state.fetchedAt < STALE_MS
      ) {
        return;
      }
      commit('setLoading', true);
      try {
        const { data } = await axios.post('/api/admin/jobs/counts', {
          presets: requests,
        });
        commit('setTotals', {
          counts: data?.counts || {},
          revenues: data?.revenues || {},
        });
      } catch (error) {
        // Non-fatal: keep the last known counts.
        // eslint-disable-next-line no-console
        console.warn('Failed to fetch job preset counts', error);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
